"use client"
import DateTimeElement from "@/app/(site)/_components/GCMolecules/DateTimeElement"
import HeadingGroup from "@/app/(site)/_components/SanityGroups/HeadingGroup"
import SubHeadingGroup from "@/app/(site)/_components/SanityGroups/SubHeadingGroup"
import { gapClass } from "@/config/fontConfig/gapClass"
import { type TextColorType } from "@/gc-sanity-types"
import { type HeadingGroupType, type SubHeadingGroupType } from "@/types/gc-modules-types"
import { clsx } from "@/src/utils/clsx"

type EditorialHeaderBlockProps = {
    date?: { time?: string }
    headingGroup?: HeadingGroupType
    subHeadingGroup?: SubHeadingGroupType
    author?: string
    isAboveTheFold?: boolean
    textColor?: TextColorType
}

export default function EditorialHeaderBlock({
    date,
    author,
    headingGroup,
    subHeadingGroup,
    isAboveTheFold,
    textColor
}: EditorialHeaderBlockProps) {
    return (
        <div className="col-span-4 sm:col-span-8 md:col-span-12">
            {date?.time && (
                <div className="col-span-4 mb-20 sm:col-span-4 sm:mb-24 md:col-span-6">
                    <DateTimeElement
                        time={date.time}
                        className={textColor || "text-main-black"}
                    />
                </div>
            )}

            <div
                className={clsx(
                    "grid gap-16 !gap-y-0",
                    "col-span-4 sm:col-span-8 md:col-span-12",
                    "sm:grid-cols-8 md:grid-cols-12 md:gap-24"
                )}
            >
                {headingGroup && (
                    <div className="col-span-4 sm:col-span-4 md:col-span-6 md:col-start-1">
                        <HeadingGroup
                            data={headingGroup}
                            isAboveTheFold={!!isAboveTheFold}
                            className={clsx(
                                "flex max-w-[824px] flex-col sm:!mb-0 md:!mb-0",
                                (subHeadingGroup || author) &&
                                    gapClass(
                                        headingGroup?.headingGroupContent?.styleKey ||
                                            "Trade_Gothic_Header_32_105_0_300"
                                    ),
                                !subHeadingGroup && !author && "!mb-0"
                            )}
                        />
                    </div>
                )}

                {(subHeadingGroup || author) && (
                    <div className="col-span-4 flex flex-col sm:col-span-4 md:col-span-5 md:col-start-8">
                        <div className="flex w-full flex-col items-start md:items-end">
                            <div className="flex flex-col">
                                {subHeadingGroup && (
                                    <SubHeadingGroup
                                        {...subHeadingGroup}
                                        className={clsx(
                                            author ? "mb-24 md:mb-40" : "!mb-0",
                                            "w-full max-w-[542px] md:w-auto"
                                        )}
                                        textColor={textColor || "text-main-black"}
                                    />
                                )}
                                {author && (
                                    <p className="w-full max-w-[542px] text-neutral-500 Trade_Gothic_Text_16_150_0_300 md:w-auto">
                                        {author}
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}
